module.exports = __webpack_public_path__ + "static/media/icon-yahoo.32b162e3.svg";